import { render } from "./KnowhowTip5.vue?vue&type=template&id=1e3808be"
import script from "./KnowhowTip5.vue?vue&type=script&lang=js"
export * from "./KnowhowTip5.vue?vue&type=script&lang=js"

import "./KnowhowTip5.vue?vue&type=style&index=0&id=1e3808be&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__